module.exports = __webpack_public_path__ + "static/media/welcome-logomark.41965555.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welcome-logomark.png
// module id = 1214
// module chunks = 0